//import liraries
import React, { useState, useRef, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import CText from './CText';
import CustomInput from '../common/CustomInput';
import Countdown from "react-countdown";
import CustomButton from '../common/CustomButton';
import { getEncKey, validateOtpWithToken } from '../api/apiManager';
import { Encryption as encrypt } from '../utilities/Encryption';
import { get } from 'lodash'
import ModalAlert from '../common/ModalAlert';
import Loader from '../common/Loader';

// create a component
const OtpModal = (props) => {
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false);
  const [timerState, setTimeState] = useState("");
  const [encKey, setEncKey] = useState("");
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });
  const counterRef = useRef(null);
  const otpPattern = /^\d{6}$/

  const completeTime = () => {
    if (
      timerState.times.length - 1 <=
      timerState.times.indexOf(timerState.currentTime)
    )
      return;
    // move to next time
    timerState.currentTimeIndex++;
    timerState.currentTime = new Date(
      timerState.times[timerState.currentTimeIndex + 1]
    );
  };
  useEffect(() => {

    setTimeState({
      times: [
        Date.now() + 5000,
        Date.now() + 12000,
        Date.now() + 17000,
        Date.now() + 22000,
      ],
      currentTimeIndex: 0,
      currentTime: Date.now() + 60000,
    });
  }, []);
  const timerRenderer = ({ hours, minutes, seconds, completed, api }) => {
    if (completed || isNaN(minutes)) {
      return (
        <>
          <Text>{"00:00"}</Text>
          <TouchableOpacity
            onPress={() => {
              setTimeState({
                times: [
                  Date.now() + 5000,
                  Date.now() + 12000,
                  Date.now() + 17000,
                  Date.now() + 22000,
                ],
                currentTimeIndex: 0,
                currentTime: Date.now() + 60000,
              });
              setTimeout(() => {
                api.start();
              }, 500);
              props.getOtp()
            }}
          >
            <Text style={[styles.resendTextStyle, { color: "red" }]}>{"Resend"}</Text>
          </TouchableOpacity>
        </>
      );
    }
    return (
      <>
        <Text>
          {minutes}:{seconds}
        </Text>
        <View>
          <Text style={[styles.resendTextStyle, { color: "gray" }]}>
            {"Resend"}
          </Text>
        </View>
      </>
    );
  };
  const onCloseModal = () => {
    setAlertModalVisible(false)
    props.isModalVisible(false)
  };

  const validateOtpWithEncryption = async () => {
    setLoading(true);
    await getEncData()
    encrypt("newidfc13", encKey).then((cyperOldUserId) => {
      encrypt("newUserId", encKey).then((cyperNewUserId) => {
        encrypt("password", encKey).then((cyperConfirmPassword) => {
          let params = {
            type: "customizeUserId",
            otp: otp,
            requestId: get(props, "data.response.otp", "").toString(),
            userId: cyperOldUserId,
            newUserId: cyperNewUserId,
            password: cyperConfirmPassword,
          };
          validateOtpWithToken(params)
            .then((res) => {
              setLoading(false);
              if (res?.statusCode === 1020 || res?.statusCode === 1003) {
                setAlertModal({
                  title: "Success",
                  status: "success",
                  message: res.message,
                  navigateScreen: "",
                  actionButton: "OK",
                });
                setAlertModalVisible(true);
                setOtp("");
                 } else {
                setAlertModal({
                  title: "Error",
                  status: "error",
                  message: res.message,
                  navigateScreen: "",
                  actionButton: "OK",
                });
                setAlertModalVisible(true);
                setOtp("");
              }
            })
            .catch((err) => {
              setLoading(false);
              setOtp("");
              console.log(
                "<------------ error in validate otp contact details api ----------->",
                err
              );
            });
        })
      })
    })
  }
  const validateOtp = async () => {
    setLoading(true);
          let params = {
            type: props.type,
            otp: otp,
            requestId: get(props, "data.response.otp", "").toString(),
            id : global.userId
          };
          validateOtpWithToken(params)
            .then((res) => {
              setLoading(false);
              if (res?.statusCode === 1020 || res?.statusCode === 1003 || res?.statusCode == 1008 ) {
                if(get(props, "type", "") == "usedCarLoan" && get(props, "data.response.otp", "").toString() != res?.data?.requestId ){
                  setAlertModal({
                    title: "Error",
                    status: "error",
                    message: "Otp has not been validated",
                    navigateScreen: "",
                    actionButton: "OK",
                  });
                  setAlertModalVisible(true);
                  setOtp("");
                }else{
                  if(props.navigation) props.onSuccess(props.navigation)
                  else props.onSuccess()
                }
              } else {
                setAlertModal({
                  title: "Error",
                  status: "error",
                  message: res.message,
                  navigateScreen: "",
                  actionButton: "OK",
                });
                setAlertModalVisible(true);
                setOtp("");
              }
            })
            .catch((err) => {
              setLoading(false);
              setOtp("");
              console.log(
                "<------------ error in validate otp contact details api ----------->",
                err
              );
            });
  }
  const getEncData = () => {
    let req = { deviceId: "KA03MP1234" }
    getEncKey(req).then(res => setEncKey(res.data)).catch(err => setEncKey(""))
  }
  return (
    <View style={styles.overlayViewStyle}>
      <View style={styles.overlayContainer}>
        <View style={styles.overlay}>
          <View style={styles.overlayContentViewStyle}>

            <CText.otpTitle>Enter OTP</CText.otpTitle>
            <CText.otpDesc>{props.data.message}</CText.otpDesc>

            <View style={{ alignSelf: "center" }}>
              <CustomInput
                onValueChanged={setOtp}
                value={otp}
                keyboardType="numeric"
                pattern={/^\d{6}$/}
                errorMessage={"Enter Valid OTP"}
                maxLength={6}
                style={[styles.otpInputViewStyle, { alignSelf: "center" }]}
              />
            </View>
            <View style={styles.resendViewStyle}>
              <Countdown
                ref={counterRef}
                date={timerState.currentTime}
                key={timerState.currentTimeIndex}
                onComplete={completeTime}
                intervalDelay={0}
                precision={3}
                renderer={timerRenderer}
              />
            </View>
            <View
              style={{
                width: 123.5,
                height: 36,
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <CustomButton
                text={"Submit"}
                onPress={() => {
                  !otpPattern.test(otp) ? "" : validateOtp();
                }}
                disable={!otpPattern.test(otp) ? true : false}

              />
            </View>
          </View>
        </View>
      </View>
      {alertModalVisible ? (
        <ModalAlert
          title={alertModal.title}
          status={alertModal.status}
          message={alertModal.message}
          navigateScreen={alertModal.navigateScreen}
          actionButton={"OK"}
          onCloseModal={onCloseModal}
        />
      ) : null}
      {loading && <Loader />}
    </View>
  );
};

// define your styles
const styles = StyleSheet.create({
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 15,
  },
  overlayContainer: {
    width: "100%",
    height: "100%",
    zIndex: 99999,
  },
  overlay: {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  overlayContentViewStyle: {
    width: 348.1,
    height: 269.7,
    borderRadius: 13,
    backgroundColor: "#ffffff",
    shadowColor: "rgba(0, 0, 0, 0.05)",
    shadowOffset: {
      width: 0,
      height: 27,
    },
    shadowRadius: 34,
    shadowOpacity: 1,
  },
  otpInputViewStyle: {
    width: 250.4,
    height: 38,
    backgroundColor: "rgba(0, 0, 0, 0)",
    borderStyle: "solid",
    borderWidth: 1.5,
    borderColor: "#dfdfdf",
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: "bold",
    fontStyle: "normal",
    lineHeight: 14,
    letterSpacing: 3.6,
    textAlign: "left",
    color: "#66625f",
    borderRadius: 5,
    marginTop: 20,
    alignSelf: "center",
    paddingLeft: 10,
  },
  resendViewStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: "15%",
    marginTop: 5,
  },
});

//make this component available to the app
export default OtpModal;
